import { Navigation } from "../swiper/swiperConfig";

const configFontsSlider = {
  allowTouchMove: false,
  direction: "horizontal",
  speed: 800,
  spaceBetween: 24,
  loop: true,
  module: [Navigation],
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    950: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
    1280: {
      slidesPerView: 3,
      spaceBetween: 24,
    },
    1440: {
      slidesPerView: 4,
      spaceBetween: 24,
    },
  },
};

export default configFontsSlider;
